<template>
    <div
        style="max-height: 300px"
        class="overflow-y-auto overflow-x-hidden">
        <p
            v-for="(item, index) in data"
            :key="index">
            {{ item }} <br v-if="index < data.length - 1" >
        </p>
    </div>
</template>
<script lang="ts" setup>
const store = $store()
const props = defineProps({
  params: Object
})

const { params } = toRefs(props)

const data: any = ref([])

onBeforeMount(() => {
  try {
    const businessIds = Object.keys(params?.value?.data.businesses)
    let taskNames: string[] = []
    const tasks = store.data.getTasks
    if (Array.isArray(businessIds) && params?.value?.data?.businesses) {
      businessIds.forEach((id: string) => {
        taskNames = [...taskNames, ...tasks.filter((task: any) => params?.value?.data?.businesses[id]?.includes(task._id)).map((task: any) => task.name)]
      })
    }

    data.value = Array.from(new Set(taskNames))
  } catch (e) {
    data.value = []
  }
})
</script>
